
(function () {

    a3_pilot_reports.directive('reportsPanel', reportsPanel);

    /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name reportsPanel
   * @restrict E
   * @description
   *   Implementation of reportsPanel
   *   Initialize the panels with reports.
   * @example
   *   Usage:
   *   <reports-panel flight-id="id"></reports-panel>
   * @ngInject
   */
    function reportsPanel($location, defaultCalendarDate) {
        function link($scope, element, attrs) {
            $scope.togglePanel = togglePanel;

            var flight = $scope.flight;
            $scope.showSafetyReport = showSafetyReport();
            //Initialize CSS classes
            $scope.getTextClass = getTextClass();
            $scope.getTopClass = getTopClass();
            $scope.getBottomClass = getBottomClass();
            $scope.hasIcon = hasIcon();
            $scope.openCabinReport = openCabinReport;

            /**
             * toggle Panel
             * @memberof FlightInfoCtrl
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

            function showSafetyReport(){
                var today = new Date().toUTC();
                if(defaultCalendarDate){
                    today = new Date(defaultCalendarDate).toUTC();
                }
                var flightDate = new Date(flight.FlightDate);
                var trimmedToday = new Date(today);
                var trimmedFlightDate = new Date(flightDate);
                var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedFlightDate.trimTime());

                return diffDays <= 0;
            }
            
            /**
             * Return the text ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTextClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "text-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "text-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "text-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "text-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "text-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "text-green";
                }
                return classname;
            }

            /**
             * Return the panel upper ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getTopClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "border-top-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "border-top-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "border-top-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-top-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-top-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-top-green";
                }
                return classname;
            }

            /**
             * Return the panel border ccs class accoriding to report status
             * @memberof FlightInfoCtrl
             * @returns {string} cssClass
             */
            function getBottomClass() {
                var classname = "";
                if (flight.LineStatus === 'na')
                    classname = "border-bottom-gray";
                else if (flight.LineStatus === 'pending')
                    classname = "border-bottom-blue";
                else if (flight.LineStatus === 'pendingoverdue')
                    classname = "border-bottom-blue";
                else if (
                    (flight.LineStatus === 'draft') ||
                    (flight.LineStatus === 'draftotheruser')
                ) {
                    classname = "border-bottom-orange";
                } else if (
                    (flight.LineStatus === 'completed') ||
                    (flight.LineStatus === 'completedotheruser')
                ) {
                    classname = "border-bottom-purple";
                } else if (
                    (flight.LineStatus === 'stored') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synched') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    classname = "border-bottom-green";
                }
                return classname;
            }

            /**
             * If report from another user exists, show icon
             * @memberof FlightInfoCtrl
             * @returns {boolean} hasIcon
             */
            function hasIcon() {
                var hasIcon = false;
                if (
                    (flight.LineStatus === 'draftotheruser') ||
                    (flight.LineStatus === 'completedotheruser') ||
                    (flight.LineStatus === 'storedotheruser') ||
                    (flight.LineStatus === 'stored+otheruser') ||
                    (flight.LineStatus === 'synchedotheruser')
                ) {
                    hasIcon = true;
                }
                return hasIcon;
            }

             /**
             * Redirects to cabin report page
             * @memberof FlightInfoCtrl
             * @returns {boolean} hasIcon
             */
            function openCabinReport() {
                $location.path("reportsHistory/" + flight.CabinReportId + "/" + flight.FlightId+"/Cabin");
            }

        }



        return {
            restrict: 'E',
            templateUrl: "views/directives/reportsPanel.tpl.html",
            scope: false,
            terminal: true,
            link: link
        }
    }
})();